// extracted by mini-css-extract-plugin
export var container = "NewsMedia-module--container---iOZ9";
export var newsMediaLink = "NewsMedia-module--newsMediaLink--npGkk";
export var mediaBg = "NewsMedia-module--mediaBg--XtgkK";
export var bgMedia = "NewsMedia-module--bgMedia--q5f9c";
export var bgCeo = "NewsMedia-module--bgCeo---vA1h";
export var mediaIcon = "NewsMedia-module--mediaIcon--+f1Er";
export var mediaBgFlame = "NewsMedia-module--mediaBgFlame--oH5L5";